module.exports = __webpack_public_path__ + "us.da80e9f32512c65921b9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/us.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/us.svg
// module chunks = styles